import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './DetailHeader.styles'
import { TextContext } from 'hocs'
import DOMPurify from 'dompurify'

// component stack
import { Icon, Link } from 'components/atoms'
import Bookmark from 'components/organisms/SearchHeader/partials/Bookmark/Bookmark'
import * as Component from 'components/organisms/SearchHeader/SearchHeader.styles'
import { useHistory } from 'react-router'

/**
 * functional container for all detail views
 * @returns {*}
 * @constructor
 */
const DetailHeader = (props) => {
  const {
    headline = '',
    backLink = null,
    detailLink = null,
    bookmarkCount,
    onBookmarkButtonClicked,
    onCompareButtonClicked,
  } = props

  const textContext = useContext(TextContext)
  const showHeaderNavigation = onBookmarkButtonClicked || onCompareButtonClicked
  const bookmarkButtonRef = React.useRef(null)
  const compareButtonRef = React.useRef(null)
  const history = useHistory()

  const getLinkByType = (type) => {
    const link = type === 'backLink' ? backLink : detailLink

    return (
      <Link
        id={ link.id }
        to={ link.to }
        className={ `link ${ type === 'backlink' ? 'back-link' : 'more-link' }` }
        onClick={
          link.to.includes('/null')
            ? (e) => {
                e.preventDefault()
                history.goBack()
              }
            : null
        }>
        {
          textContext[
            `navigation.${
              type === 'backLink' ? 'backToSearch' : 'hospitalOverview'
            }`
          ]
        }
      </Link>
    )
  }

  if (bookmarkButtonRef.current !== null && compareButtonRef !== null) {
    if (bookmarkButtonRef.current.hasOwnProperty('childNodes')) {
      const buttonWidth = parseInt(
        bookmarkButtonRef.current.childNodes[0].getBoundingClientRect().width,
        10
      )
      compareButtonRef.current.childNodes[0].style.width = `${ buttonWidth }px`
    }
  }

  return (
    <>
      <h1 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(headline) }} />
      <Styled.LinkContainer>
        <div
          className={ `link-row ${
            !detailLink && showHeaderNavigation ? 'half-size' : false
          } ` }>
          {backLink && getLinkByType('backLink')}
          {detailLink && getLinkByType('detailLink')}
        </div>

        {showHeaderNavigation && (
          <div
            className={ `link-row header-navigation ${
              !detailLink && showHeaderNavigation ? 'half-size' : false
            }` }>
            {onBookmarkButtonClicked && (
              <div ref={ bookmarkButtonRef }>
                <Bookmark
                  count={ bookmarkCount }
                  onBookmarkButtonClicked={ onBookmarkButtonClicked }
                />
              </div>
            )}
            {onCompareButtonClicked && (
              <div ref={ compareButtonRef }>
                <Component.CompareButton
                  id='compare-btn'
                  text={ textContext['general.compare.Link'] }
                  onClick={ onCompareButtonClicked }
                  icon={ <Icon className='icon-f-compare' /> }
                />
              </div>
            )}
          </div>
        )}
      </Styled.LinkContainer>
    </>
  )
}

DetailHeader.defaultProps = {
  bookmarkCount: false,
  onBookmarkButtonClicked: false,
  onCompareButtonClicked: false,
}

DetailHeader.propTypes = {
  headline: PropTypes.string,
  backLink: PropTypes.exact({
    to: PropTypes.string,
    id: PropTypes.string,
  }),
  detailLink: PropTypes.exact({
    to: PropTypes.string,
    id: PropTypes.string,
  }),
  bookmarkCount: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onBookmarkButtonClicked: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    .isRequired,
  onCompareButtonClicked: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    .isRequired,
}

export default DetailHeader
